import React, { useEffect, useState } from "react";
import styles from "./school-grade-scales.module.css";
import { Typography } from "antd";
import CustomButton from "../../../../../../../common/custom-button/custom-button";
import { PlusOutlined } from "@ant-design/icons";
import CustomTable from "../../../../../../../common/custom-table/custom-table";
import SVGIcon from "../../../../../../../constants/SVGIcon";
import { fetchClass } from "../../../../../../../services/student";
import { deleteGradeScales, fetchGradeScales } from "../../../../../../../services/school_info";
import AddEditGradeScales from "./components/add-edit-grade-scales/add-edit-grade-scales";
import CustomPopover from "../../../../../../../common/custom-popover/custom-popover";

const SchoolGradeScales = () => {
  const [levels, setLevels] = useState([]);
  const [gradeList, setGradeList] = useState([]);
  const [activeLevelId, setActiveLevelId] = useState();
  const [loading, setLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [editDetails, setEditDetails] = useState(null);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    setPageNo(1);
    getLevels();
  }, []);

  const getLevels = async () => {
    try {
      setLoading(true);
      const response = await fetchClass();
      if (response?.data) {
        const data = response?.data?.data?.levels;
        setLevels(data);
        setActiveLevelId(data?.[0]?.id);
        getGradeScales(data?.[0]?.id);
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const getGradeScales = async (level_id, tempPage = pageNo, tempPageSize = pageSize) => {
    try {
      setLoading(true);
      const payload = {
        level_id,
        page: tempPage,
        pageSize: tempPageSize,
      };
      const response = await fetchGradeScales(payload);
      if (response?.data) {
        const data = response?.data?.data?.gradeScales;
        setGradeList(data);
        setTotalCount(response?.data?.data?.totalRecords);
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const handleChangePage = (page, pageSize) => {
    setPageNo(page);
    setPageSize(pageSize);
    getGradeScales(activeLevelId, page, pageSize);
  };

  const handleEditGrade = (data) => {
    setEditDetails(data);
    setOpenDrawer(true);
  };

  const handleOnClose = () => {
    getGradeScales(activeLevelId);
    setOpenDrawer(false);
  };

  const handleDeleteGrade = async (id) => {
    try {
      await deleteGradeScales(id);
      getLevels();
    } catch (err) {
      console.log(err);
    }
  };

  const handleAddGrade = () => {
    setEditDetails(null);
    setOpenDrawer(true);
  };

  const handleLevelChange = (id) => {
    setPageNo(1);
    setActiveLevelId(id);
    getGradeScales(id);
  };

  const columns = [
    {
      title: "Symbol",
      dataIndex: "symbol",
      key: "symbol",
      sorter: (a, b) => a?.symbol?.localeCompare(b?.symbol),
      render: (value) => value || "-",
    },
    {
      title: "Upper Limit",
      dataIndex: "upper_limit",
      key: "upper_limit",
      sorter: (a, b) => a?.upper_limit - b?.upper_limit,
      render: (value) => value || "-",
    },
    {
      title: "Lower Limit",
      dataIndex: "lower_limit",
      key: "lower_limit",
      sorter: (a, b) => a?.lower_limit - b?.lower_limit,
      render: (value) => value || "-",
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <div className={styles.actionItemWrapper}>
          <SVGIcon
            name={"edit-icon"}
            width={"20"}
            height={"20"}
            stroke={"#3BB44B"}
            onClick={() => handleEditGrade(record)}
          />
          <CustomPopover
            message="Are you sure you want to delete this grade?"
            confirmText="Delete"
            cancelText="Cancel"
            onConfirm={() => handleDeleteGrade(record?.id)}
          >
            <SVGIcon
              name={"delete"}
              width={"20"}
              height={"20"}
              stroke={"rgba(243, 17, 17, 1)"}
            />
          </CustomPopover>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className={styles.titleContainer}>
        <Typography className={styles.tabTitle}>
          Grade Scales
        </Typography>
        <CustomButton
          title="Add New Grade"
          size="large"
          icon={<PlusOutlined />}
          onClick={handleAddGrade}
        />
      </div>

      <div className={styles.gradeTableContainer}>
        <div className={styles.levelWrapperContainer}>
          <div className={styles.levelWrapper}>
            {levels?.map(item => (
              <div style={{ width: '100%' }}>
                <CustomButton
                  title={item?.name}
                  size="large"
                  onClick={() => handleLevelChange(item?.id)}
                  className={item?.id === activeLevelId ? "" : styles.inactiveLevelButton}
                  style={{ width: "100%" }}
                />
              </div>
            ))}
          </div>
        </div>
        <div style={{ width: "100%" }}>
          <CustomTable
            columns={columns}
            dataSource={gradeList}
            loading={loading}
            headerColor="#667085"
            headerBackgroundColor="#F9FAFB"
            total={totalCount}
            pageSize={pageSize}
            currentPage={pageNo}
            handlePageChange={handleChangePage}
          />
        </div>
      </div>
      <AddEditGradeScales
        open={openDrawer} 
        onClose={handleOnClose} 
        data={editDetails}
        levels={levels}
      />
    </div>
  );
};

export default SchoolGradeScales;